import { Grid, Typography } from '@material-ui/core';
import { CoverageCatalog, Quotation } from 'data-layer-cr/dist/models';
import { DisplayItem, moneyFormat } from 'design-system';
import React from 'react';

import { endorsementCoverages } from 'data-layer-cr/dist/functions/coverages';
import { defaultUnit } from 'data-layer-cr/dist/functions/quotations';

// helper functions
import formatTitleCase from '../../../../../functions/formatTitleCase';

import { AssaMobile, CardQuotation } from '../../components';

const { formatMoney } = moneyFormat;

type Props = {
  quotation: Quotation;
  coverages: CoverageCatalog[];
  currentProfileTypeOfMoney?: string;
  additionalBenefits?: CoverageCatalog[];
};

const AdditionalCoveragesCard = ({
  quotation,
  coverages,
  currentProfileTypeOfMoney = '$',
  additionalBenefits = [],
}: Props): JSX.Element => {
  const displayItems: DisplayItem[] = [];

  // create map for easy access to corresponding endorsement catalog
  const endorsementCoveragesMap = endorsementCoverages(coverages).reduce<{
    [key: string]: CoverageCatalog;
  }>((acc, curr) => {
    // eslint-disable-next-line no-param-reassign
    acc[curr.code] = curr;
    return acc;
  }, {});

  // match endorsements in quotation with the map catalog
  defaultUnit(quotation).coverages.forEach((cov) => {
    if (endorsementCoveragesMap[cov.coverageId] !== undefined) {
      const { name, maxCost } = endorsementCoveragesMap[cov.coverageId];
      displayItems.push({
        Value: formatTitleCase(name),
        Text: formatMoney(maxCost, false, currentProfileTypeOfMoney),
      });
    }
  });

  // fallback to empty values just in case
  if (displayItems.length === 0) {
    displayItems.push({
      Value: '',
      Text: '',
    });
  }
  const packageName: React.ReactNode = (
    <Grid container>
      <img src="/svg/heart.svg" alt="heart icon" style={{ marginRight: 11 }} />
      <Typography style={{ fontSize: '19px', fontWeight: 900 }}>
        Beneficios
      </Typography>
    </Grid>
  );

  const extraBenefits: React.ReactNode = (
    <>
      {additionalBenefits.map((ab) => (
        <Grid item container>
          <Typography
            style={{ fontSize: 17, fontWeight: 400, margin: '5px 0px' }}
          >
            <img
              src="/svg/checkIconWhiteBackground.svg"
              alt="Check icon white backgroound"
              style={{ marginRight: 17 }}
            />{' '}
            {ab.name}
          </Typography>
        </Grid>
      ))}
    </>
  );

  return (
    <CardQuotation
      title={packageName}
      subTitle={
        <>
          <AssaMobile />
          {extraBenefits}
        </>
      }
      decorateFooter={displayItems[0]}
    />
  );
};

export default AdditionalCoveragesCard;
